import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Top-level error boundary. Without this, any uncaught render error (often
// from a single misbehaving subtree like the blueprint viewer on mobile)
// blanks the entire page. With this, the user sees a useful error message
// and can reload instead of staring at a black/white void.
class RootErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = {error: null}; }
  static getDerivedStateFromError(error) { return {error}; }
  componentDidCatch(error, info) {
    try { console.error("[Root error]", error, info); } catch {}
    // Persist a short crash log so we can postmortem on mobile where the
    // console is hidden by default.
    try {
      const log = JSON.parse(localStorage.getItem("grok_crash_log") || "[]");
      log.unshift({
        when: new Date().toISOString(),
        msg: String(error && error.message ? error.message : error).slice(0, 500),
        stack: String(error && error.stack ? error.stack : "").slice(0, 2000),
        componentStack: String(info && info.componentStack ? info.componentStack : "").slice(0, 1500),
        ua: (navigator.userAgent || "").slice(0, 240),
        url: (window.location && window.location.pathname) || "",
      });
      localStorage.setItem("grok_crash_log", JSON.stringify(log.slice(0, 10)));
    } catch {}
  }
  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error && this.state.error.message ? this.state.error.message : this.state.error || "Unknown error").slice(0, 400);
    return (
      <div style={{minHeight:"100dvh",background:"#0d1421",color:"#e2e8f0",fontFamily:"system-ui,-apple-system,sans-serif",display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
        <div style={{maxWidth:520,textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:14}}>⚠️</div>
          <div style={{fontSize:18,fontWeight:800,marginBottom:8}}>Something broke loading the page</div>
          <div style={{fontSize:13,color:"#94a3b8",marginBottom:20,lineHeight:1.6}}>
            Tap reload to try again. If it keeps happening, sign out and back in or contact support.
          </div>
          <div style={{background:"#1a2332",border:"1px solid #2d3f55",borderRadius:8,padding:"10px 14px",fontSize:11,color:"#94a3b8",fontFamily:"monospace",marginBottom:18,wordBreak:"break-word",textAlign:"left"}}>
            {msg}
          </div>
          <button onClick={()=>window.location.reload()}
            style={{background:"#d4a017",color:"#0d1421",border:"none",borderRadius:8,padding:"10px 22px",fontSize:13,fontWeight:800,cursor:"pointer",marginRight:8}}>
            Reload
          </button>
          <button onClick={()=>{try{localStorage.clear();sessionStorage.clear();}catch{}window.location.reload();}}
            style={{background:"transparent",color:"#94a3b8",border:"1px solid #2d3f55",borderRadius:8,padding:"10px 22px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            Clear cache &amp; reload
          </button>
        </div>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
